export enum ExportStatus {
  CREATED = "created",
  COMPLETED = "completed",
  REJECTED = "rejected",
  IN_PROGRESS = "in-progress"
}

export interface Export {
  id: string;
  number: string;
  createdAt: string; // visualizzare?
  createdBy?: {
    id: string;
    name: string;
  };
  updatedAt?: string; // non visualizzare
  deletedAt?: string; // non visualizzare
  type: "electronic-invoice"; // 'electronic-invoice'
  expiresAt?: Date;
  storageId?: string;
  status: ExportStatus;
  completedAt?: Date;
}
